import { render, staticRenderFns } from "./ShareNoteDialog.vue?vue&type=template&id=b1e0cf3c&scoped=true"
import script from "./ShareNoteDialog.vue?vue&type=script&lang=js"
export * from "./ShareNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareNoteDialog.vue?vue&type=style&index=0&id=b1e0cf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e0cf3c",
  null
  
)

export default component.exports